import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import useFetchProductClasses, { ProductClass } from './useFetchProductClasses'

type SelectOption = {
  value: string
  label: string
}

type AnnotationClassFilterProps = {
  productId: number
  initialValue?: string[]
  onChange: (v: readonly SelectOption[]) => void
}

const makeOption = (c: string) => ({
  label: c,
  value: c,
})

const toOption = (x: ProductClass) => makeOption(x.productClass)

const AnnotationClassFilter = ({
  productId,
  initialValue,
  onChange,
}: AnnotationClassFilterProps) => {
  const { t } = useTranslation()

  const { productClasses, isFetching } = useFetchProductClasses(productId)

  const [value, setValue] = useState<readonly SelectOption[]>(
    initialValue ? initialValue.map((v) => makeOption(v)) : []
  )

  const options = productClasses ? productClasses.map(toOption) : []

  return (
    <AdvancedSelect
      name="annotationClassFilter"
      id="annotationClassFilter"
      isClearable
      label={t('Class')}
      placeholder={t('Filter...')}
      value={value}
      onChange={(v: readonly SelectOption[]) => {
        setValue(v)
        onChange(v)
      }}
      isLoading={isFetching}
      options={options}
      isMulti
    />
  )
}

export default AnnotationClassFilter
